type FormatNumberOptions = {
  allowedDecimalPlaces: number;
};

export function formatNumber(
  n: number | string | null | undefined,
  options: FormatNumberOptions = { allowedDecimalPlaces: 0 },
) {
  if (typeof n !== 'number' && typeof n !== 'string') return '-';

  const asNumber = Number(n);
  const isNumber = !isNaN(asNumber) && isFinite(asNumber);
  return isNumber
    ? asNumber.toLocaleString(undefined, {
        minimumFractionDigits: options.allowedDecimalPlaces,
        maximumFractionDigits: options.allowedDecimalPlaces,
        ...options,
      })
    : '-';
}
